import { createAsyncThunk } from '@reduxjs/toolkit';
import BigNumber from 'bignumber.js';

import { RootState } from '../../..';
import { getErrorText } from '../helpers';

export const checkUserRaiseHandMsg = createAsyncThunk<
  { messageTT: string | number | null },
  { roomId: string; messageTimeToken: string },
  { rejectValue: string }
>('pubnub/checkUserRaiseHandMsg', async (data, { rejectWithValue, getState }) => {
  try {
    const pubnubReducer = (getState() as RootState).pubnub;

    if (pubnubReducer.pubnub) {
      const endTimeBI = new BigNumber(data.messageTimeToken);
      const startTimeBI = endTimeBI.plus(new BigNumber(1));

      const result = await pubnubReducer.pubnub.fetchMessages({
        channels: [data.roomId],
        start: startTimeBI.valueOf(),
        end: `${data.messageTimeToken}`,
      });

      return { messageTT: result.channels[`${data.roomId}`]?.[0]?.timetoken || null };
    } else {
      throw new Error('PubnubInstanceIsNull');
    }
  } catch (e) {
    return rejectWithValue(getErrorText(e as Error));
  }
});
